<template>
    <div class="app-container">
      <BjPage ref="BjPage" :get-action="queryApi" :query-params="queryParams" :label-width="'80px'" :col-span="colSpan" :before-reset-search="beforeResetSearch" :cell-class-name="actualCellClassName" @afterFetchOriginalData="afterFetchOriginalData" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <template v-slot:baseForm>
          <!-- 年-周 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('billingPage.yearAndWeek')" prop="year">
              <el-date-picker
                id="getWeekDate"
                v-model="weekDataNow"
                :picker-options="{ firstDayOfWeek: 1 }"
                style="width: 100%"
                type="week"
                format="yyyy-WW"
                :clearable="false"
                :placeholder="$t('billingPage.yearAndWeeks')"
                @change="handleQuery"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="colSpan">
            <el-form-item :label="$t('AccountManagement.staff.department')" prop="department">
              <BjSelectLov v-model="queryParams.department" :option-list="staffDepartmentList" :clearable="!deptDis" :placeholder="$t('AccountManagement.staff.department')" @change="handleQuery" />
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:tableOperation>
          <el-col>
            <!-- 导入员工请假记录 -->
            <el-button v-if="havePermission" class="main-btn" @click="importStaffButton()">{{ $t('AccountManagement.staffLeave.importLeave') }}</el-button>
            <el-button v-if="havePermission" @click="$refs.staffLeaveDialog.open()">{{ $t('AccountManagement.staffLeave.viewLeave') }}</el-button>
            <!-- 工时文件导出 -->
            <el-button type="primary" class="main-btn" @click="onExport">{{ $t('exportText') }}</el-button>
          </el-col>
        </template>
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop === 'weekDay'">
                  <span>{{ scope.row.weekDay }} {{ timeFilters(scope.row.date) }}</span>
                </template>
                <template v-else-if="col.prop === 'plan'">
                  <span class="link" @click="onPlan(scope.row,'viewPlan')">{{ scope.row.plan }}</span>
                </template>
                <template v-else-if="col.prop === 'actual'">
                  <span class="link" @click="onActual(scope.row,'viewActual')">{{ scope.row.actual }}</span>
                </template>
                <template v-else-if="col.prop === 'approveStatus'">
                  <span v-if="scope.row[col.prop] != '超用驳回'"> {{ $t(DEPT_HOURS_HEADCOUNT_SATATUS.bjGet(scope.row[col.prop])) }} </span>
                  <el-tooltip v-else class="item" effect="dark" :content="scope.row.planOperation" placement="top">
                    <span> {{ $t(DEPT_HOURS_HEADCOUNT_SATATUS.bjGet(scope.row[col.prop])) }} <i class="el-icon-warning" style="color:red"></i> </span>
                  </el-tooltip>
                </template>
                <template v-else-if="col.prop === 'overtimeApproveStatus'">
                  <span v-if="scope.row[col.prop] != '加班计划驳回'"> {{ $t(DEPT_HOURS_OVERTIME_SATATUS.bjGet(scope.row[col.prop])) }} </span>
                  <el-tooltip v-else class="item" effect="dark" :content="scope.row.overtimeOperation" placement="top">
                    <span> {{ $t(DEPT_HOURS_OVERTIME_SATATUS.bjGet(scope.row[col.prop])) }} <i class="el-icon-warning" style="color:red"></i> </span>
                  </el-tooltip>
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button :disabled="['计划用人审批中','实际用人待申报','已完成'].includes(props.row.approveStatus) || isWeekendRow(props.row)" type="text" class="edit-btn" @click="onPlan(props.row)">{{ $t('AccountManagement.work.plan') }}</el-button>
                <el-button :disabled="['计划用人待申报','计划用人审批中','超用驳回','已完成'].includes(props.row.approveStatus) || isWeekendRow(props.row)" type="text" class="edit-btn" @click="onActual(props.row)">{{ $t('AccountManagement.work.actual') }}</el-button>
                <el-button type="text" class="edit-btn" @click="onOverTime(props.row)">{{ $t('AccountManagement.work.over') }}</el-button>
                <el-button type="text" class="edit-btn" @click="$refs.ReviewDialog.show(props.row.date)">{{ $t('AccountManagement.work.review') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <ReviewDialog ref="ReviewDialog" :departments="staffDepartmentList" :department-labels="staffDeptList" />
      <StaffLeaveDialog ref="staffLeaveDialog" />
      <!-- 计划用工 -->
      <PlanForm v-if="isShowForm" ref="PlanForm" @reFresh="reFresh" />
      <!-- 实际用工 -->
      <ActualForm v-if="isShowForm" ref="ActualForm" @reFresh="onTimesheetChanged" :staff-role-list="staffRoleList" :staff-dept-list="staffDeptList"/>
      <!-- 加班 -->
      <OverTimeForm v-if="isShowForm" ref="OverTimeForm" @reFresh="onTimesheetChanged" :staff-role-list="staffRoleList" :staff-dept-list="staffDeptList"/>
      <el-dialog
        :title="$t('AccountManagement.work.exportTimesheetReport')"
        :visible.sync="exportDialogVisible"
        width="720px"
        class="export-timesheet-dialog"
        :before-close="handleExportClose"
      >
        <el-form ref="exportForm" :model="exportForm" :rules="exportRules" label-width="150px" class="export-timesheet-form">
          <el-form-item :label="$t('AccountManagement.work.employeeType')" prop="employeeType" class="export-employee-type-item">
            <el-radio-group v-model="exportForm.employeeType" class="export-employee-type" @change="handleExportEmployeeTypeChange">
              <el-radio label="fullTime">{{ $t('AccountManagement.work.fullTimeBiWeekly') }}</el-radio>
              <el-radio label="casual">{{ $t('AccountManagement.work.casualWeekly') }}</el-radio>
              <el-radio label="labour">{{ $t('AccountManagement.work.labourHire') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('AccountManagement.work.period')" prop="period">
            <BjSelectLov
              v-model="exportForm.period"
              :option-list="currentExportPeriodOptions"
              :placeholder="$t('AccountManagement.work.pleaseSelect')"
              class="export-period-select"
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleExportClose">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" @click="handleExportConfirm">{{ $t('exportText') }}</el-button>
        </div>
      </el-dialog>
      <el-dialog :title="$t('AccountManagement.staffLeave.importLeave')" :visible.sync="importDialogVisible" width="600px" :close-on-click-modal="false" :before-close="handleImportStaffClose" @closed="resetImportStaffDialog">
        <el-upload
          ref="importStaffUpload"
          class="import-staff-upload"
          drag
          action=""
          accept=".xls,.xlsx"
          :limit="1"
          :file-list="importStaffFileList"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="handleImportStaffFileChange"
          :on-exceed="handleImportStaffFileExceed"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">{{ $t('UploadMainText1') }}<em>{{ $t('UploadMainText2') }}</em></div>
        </el-upload>
        <div v-if="importStaffFile" class="import-staff-file-row">
          <div class="import-staff-file-name">
            <i class="el-icon-document"></i>
            <span>{{ importStaffFile.name }}</span>
            <el-button type="text" icon="el-icon-close" :disabled="importing" @click="clearImportStaffFile"></el-button>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button :disabled="importing" @click="handleImportStaffClose">{{ $t('cancelText') }}</el-button>
          <el-button type="primary" :loading="importing" @click="confirmImportStaff">{{ $t('ConfirmImportText') }}</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
    import pageMiXin from '@/utils/page-mixin.js';
    import { funConfigApi } from '@/api';
    import { DEPT_HOURS_HEADCOUNT_SATATUS,DEPT_HOURS_OVERTIME_SATATUS } from '@/utils/constants';
    import { downloadBlob } from '@/utils/index';
    import { timeFilters } from '@/filters'
    import PlanForm from './PlanForm.vue';
    import ActualForm from './ActualForm.vue';
    import OverTimeForm from './OverTimeForm.vue';
    import ReviewDialog from './ReviewDialog.vue';
    import StaffLeaveDialog from './StaffLeaveDialog.vue';

    export default {
      name: 'BusinessUserTimeManagement',
      components: { PlanForm, ActualForm, OverTimeForm, ReviewDialog, StaffLeaveDialog },
      mixins: [pageMiXin],
      data() {
        return {
          colSpan: 4,
          DEPT_HOURS_HEADCOUNT_SATATUS,
          DEPT_HOURS_OVERTIME_SATATUS,
          queryApi: funConfigApi.getWorkforceList,
          queryParams: {
            department: null,
            weekOfYear: null,
          },
          // 年-周 数据
          weekDataNow: new Date(),
          // 部门下拉列表
          staffDepartmentList:[],
          // 部门下拉列表(全部)
          staffDeptList:[],
          // 部门下拉列表是否可以清除数据
          deptDis:false,
          // 部门下拉列表暂存数据
          staffDepartmentDisvalue:null,
          labelList: [
            { label: this.$t('AccountManagement.work.weekDay'), prop: 'weekDay', isCheck: true, disabled: false, },
            { label: this.$t('AccountManagement.work.recommended'), prop: 'recommended', isCheck: true, disabled: false, },
            { label: this.$t('AccountManagement.work.plan'), prop: 'plan', isCheck: true, disabled: false, },
            { label: this.$t('AccountManagement.work.actual'), prop: 'actual', isCheck: true, disabled: false, },
            { label: this.$t('AccountManagement.work.Headcount'), prop: 'approveStatus', isCheck: true, disabled: false, },
            { label: this.$t('AccountManagement.work.Overtime'), prop: 'overtimeApproveStatus', isCheck: true, disabled: false, },
            { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 260 },
          ],
          // 工种下拉列表
          staffRoleList: [
            {label:'Forklift Driver',value:'1'},
            {label:'Inbound Supervisor',value:'2'},
            {label:'Receiver',value:'3'},
            {label:'Container Unpacker',value:'4'},
            {label:'Return Staff',value:'5'},
            {label:'Picker',value:'6'},
            {label:'Counterbalance Driver',value:'7'},
            {label:'Outbound Supervisor',value:'8'},
            {label:'Forklift Picker',value:'9'}
          ],
          isShowForm:false,
          exportDialogVisible: false,
          exportForm: {
            employeeType: 'fullTime',
            period: '',
          },
          exportRules: {
            employeeType: [{ required: true, message: this.$t('AccountManagement.work.pleaseSelect'), trigger: 'change' }],
            period: [{ required: true, message: this.$t('AccountManagement.work.pleaseSelect'), trigger: 'change' }],
          },
          exportFortnightlyList: [],
          exportWeeklyList: [],
          exportLabourList: [],
          importing: false,
          importDialogVisible: false,
          importStaffFile: null,
          importStaffFileList: [],
        };
      },
      computed: {
        permissionBtns() {
          return this.$store.getters.userPermissionBtns || [];
        },
        havePermission() {
          return this.permissionBtns.includes('BusinessStaffManagementButton'.toLocaleLowerCase());
        },
        currentExportPeriodOptions() {
          if (this.exportForm.employeeType === 'fullTime') return this.exportFortnightlyList;
          if (this.exportForm.employeeType === 'casual') return this.exportWeeklyList;
          if (this.exportForm.employeeType === 'labour') return this.exportLabourList;
          return [];
        },
      },
      watch: {
        'weekDataNow'() {
          if (this.weekDataNow !== null) {
            this.$nextTick(() => {
              this.queryParams.weekOfYear = document.querySelector('#getWeekDate').value;
            });
          }
        },
        '$route.query.pageType': {
          immediate: true,
          handler: _.debounce(function(newType) {
            if (!newType) return;
            
            // 1. 销毁所有旧表单
            this.destroyAllForms();
            
            // 2. 解析参数
            const params = {
              department: this.$route.query.department || '0',
              workDate: this.$route.query.workDate,
              recommended: this.$route.query.recommended || '0'
            };
            this.isShowForm = false; // 独立控制Actual的显示
            // 3. 根据类型打开对应表单
            switch (newType) {
              case 'PlanDetails':
                this.openForm('PlanForm', {
                  ...params,
                  recommended: params.recommended
                });
                break;
                
              case 'ActualDetails':
                this.openForm('ActualForm', params);
                break;
                
              case 'OvertimeDetails':
                this.openForm('OverTimeForm', params);
                break;
            }
          }, 300)
        },
      },
      mounted() {
        this.getStaffDeptPull();
        this.getExportFortnightly();
        this.getExportWeekly();
        this.getExportLabour();
      },
      methods: {
        onTimesheetChanged() {
          this.$refs.ReviewDialog && this.$refs.ReviewDialog.reloadIfVisible();
          this.reFresh();
        },
        getExportFortnightly() {
          funConfigApi.exportFortnightly().then(res => {
            const list = Array.isArray(res) ? res : [];
            this.exportFortnightlyList = list
              .filter(item => item)
              .map(item => {
                return { label: item, value: item };
              });
          });
        },
        getExportWeekly() {
          funConfigApi.exportWeekly().then(res => {
            const list = Array.isArray(res) ? res : [];
            this.exportWeeklyList = list
              .filter(item => item)
              .map(item => {
                return { label: item, value: item };
              });
          });
        },
        getExportLabour() {
          funConfigApi.exportLabour().then(res => {
            const list = Array.isArray(res) ? res : [];
            this.exportLabourList = list
              .filter(item => item)
              .map(item => {
                return { label: item, value: item };
              });
          });
        },
        onExport() {
          this.exportDialogVisible = true;
          this.resetExportForm();
        },
        resetExportForm() {
          this.exportForm = {
            employeeType: 'fullTime',
            period: '',
          };
          this.$nextTick(() => {
            this.$refs.exportForm && this.$refs.exportForm.clearValidate();
          });
        },
        handleExportClose() {
          this.exportDialogVisible = false;
          this.resetExportForm();
        },
        handleExportEmployeeTypeChange() {
          this.exportForm.period = '';
          this.$nextTick(() => {
            this.$refs.exportForm && this.$refs.exportForm.clearValidate('period');
          });
        },
        buildExportBlob(data) {
          if (data instanceof Blob) return data;

          const content = data || '';
          const bytes = new Uint8Array(content.length);
          for (let i = 0; i < content.length; i++) {
            bytes[i] = content.charCodeAt(i) & 0xff;
          }
          return new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        },
        handleExportConfirm() {
          this.$refs.exportForm.validate(valid => {
            if (!valid) return;
            const params = {
              employeeType: this.exportForm.employeeType,
              preiod: this.exportForm.period,
            };
            funConfigApi.exportWorkFile({
              ...params,
            }).then(res => {
              if (!res.failed) {
                const blob = this.buildExportBlob(res instanceof Blob ? res : res.message);
                downloadBlob(blob, `${params.employeeType} - ${params.preiod}.xlsx`);
                this.exportDialogVisible = false;
              }
            });
          });
        },
        importStaffButton() {
          this.importDialogVisible = true;
        },
        setImportStaffFile(rawFile, uploadFile) {
          if (!rawFile) return;
          this.importStaffFile = rawFile;
          this.importStaffFileList = [
            uploadFile || {
              name: rawFile.name,
              uid: rawFile.uid || Date.now(),
              status: 'ready',
              raw: rawFile,
            },
          ];
          this.resetImportStaffUploadInput();
        },
        clearImportStaffFile() {
          this.importStaffFile = null;
          this.importStaffFileList = [];
          this.$nextTick(() => {
            this.$refs.importStaffUpload && this.$refs.importStaffUpload.clearFiles();
            this.resetImportStaffUploadInput();
          });
        },
        resetImportStaffUploadInput() {
          const upload = this.$refs.importStaffUpload;
          const uploadInner = upload && upload.$refs && upload.$refs['upload-inner'];
          const input = uploadInner && uploadInner.$refs && uploadInner.$refs.input;
          if (input) {
            input.value = null;
          }
        },
        handleImportStaffFileChange(file) {
          this.setImportStaffFile(file && file.raw, file);
        },
        handleImportStaffFileExceed(files) {
          this.setImportStaffFile(files && files[0]);
        },
        handleImportStaffClose() {
          if (this.importing) return;
          this.importDialogVisible = false;
        },
        resetImportStaffDialog() {
          this.clearImportStaffFile();
        },
        async confirmImportStaff() {
          if (this.importing) return;
          if (!this.importStaffFile) {
            this.$message.warning(this.$t('ExcelConfig.upload'));
            return;
          }
          this.importing = true;
          try {
            const res = await funConfigApi.importWorkforceStaffLeave({ file: this.importStaffFile });
            if (!res.failed) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.importDialogVisible = false;
              this.onTimesheetChanged();
            }
          } catch (error) {
            console.error(error);
          } finally {
            this.importing = false;
          }
        },
        async destroyAllForms() {
          // 隐藏所有可能存在的表单
          ['PlanForm', 'ActualForm', 'OverTimeForm'].forEach(formName => {
            if (this.$refs[formName]) {
              this.$refs[formName].hide && this.$refs[formName].hide();
            }
          });
        },
        
        async openForm(formName, params) {
          this.isShowForm = true; 
          await this.$nextTick();
          if (this.$refs[formName]) {
            Object.assign(this.$refs[formName], params);
            this.$refs[formName].show();
          }
        },
        timeFilters,
        // 实际用人单元格背景色标红（approveStatus 为已完成时）
        actualCellClassName({ row, column }) {
          if (column.property === 'actual' && row.isRed === true) {
            return 'actual-cell-red';
          }
          return '';
        },
        isWeekendRow(row) {
          return ['Sat', 'Sun'].includes((row.weekDay || '').trim());
        },
        // 获取部门下拉列表数据
        getStaffDeptPull() {
          // 获取部门下拉列表数据(全部)
          funConfigApi.getWarehouseStaffDeptPull().then(res => {
            this.staffDeptList = res.map(item => {
              return {label: item.name,value:item.id }
            });
            // 获取部门下拉列表数据(部分)
            funConfigApi.getWarehouseStaffDeptPullKEY().then(resp => {
              if(resp.length > 0){
                this.deptDis = true
                this.staffDepartmentList = resp.map(item => {
                  return {label: item.name,value:item.id }
                });
                this.queryParams.department = resp[0].id
                this.staffDepartmentDisvalue = resp[0].id
                this.reFresh();
              }else{
                this.staffDepartmentList = this.staffDeptList
                this.deptDis = false
                this.queryParams.department = null
                this.staffDepartmentDisvalue = null
                this.reFresh();
              }
            });
          });
        },
        // 计划用人
        onPlan(row, mode){
          if(!this.queryParams.department) return this.$message.warning(this.$t('chooseText')+' '+this.$t('AccountManagement.staff.department'))
          this.isShowForm = true;
          this.$nextTick(() => {
            this.$refs.PlanForm.department = this.queryParams.department;
            this.$refs.PlanForm.workDate = row.date;
            this.$refs.PlanForm.recommended = row.recommended;
            this.$refs.PlanForm.isView = mode === 'viewPlan';
            this.$refs.PlanForm.show();
          });
        },
        // 实际用人
        onActual(row, mode){
          if(!this.queryParams.department) return this.$message.warning(this.$t('chooseText')+' '+this.$t('AccountManagement.staff.department'))
          this.isShowForm = true;
          this.$nextTick(() => {
            this.$refs.ActualForm.department = this.queryParams.department;
            this.$refs.ActualForm.workDate = row.date;
            this.$refs.ActualForm.isView = mode === 'viewActual';
            this.$refs.ActualForm.show();
          });
        },
        // 加班
        onOverTime(row){
          if(!this.queryParams.department) return this.$message.warning(this.$t('chooseText')+' '+this.$t('AccountManagement.staff.department'))
          this.isShowForm = true;
          this.$nextTick(() => {
            this.$refs.OverTimeForm.department = this.queryParams.department;
            this.$refs.OverTimeForm.workDate = row.date;
            this.$refs.OverTimeForm.show(this.isOverTimeReadonly(row));
          });
        },
        isOverTimeReadonly(row) {
          return !!(row.overtimeApproveStatus && ['加班计划审批中', '加班计划已通过'].includes(row.overtimeApproveStatus));
        },
        /** 重置按钮操作 */
        beforeResetSearch() {
          if(this.deptDis){
            this.queryParams.department = this.staffDepartmentDisvalue
          }else{
            this.queryParams.department = null
          }
          this.weekDataNow = new Date();
          this.queryParams.weekOfYear = null;
          return new Promise(resolve => {
            resolve();
          });
        },
      },
    };
  </script>
  <style lang="scss" scoped>
  .el-icon-s-flag {
    float: right;
    line-height: 34px;
  }
  .export-timesheet-form {
    padding: 22px 0 42px;
  }
  .export-employee-type {
    display: flex;
    flex-wrap: nowrap;
    line-height: 40px;
  }
  .export-employee-type .el-radio {
    margin-right: 34px;
  }
  .export-period-select {
    width: 100%;
  }
  .import-staff-upload {
    width: 100%;
  }
  ::v-deep .import-staff-upload .el-upload,
  ::v-deep .import-staff-upload .el-upload-dragger {
    width: 100%;
  }
  .import-staff-file-row {
    margin-top: 8px;
  }
  .import-staff-file-name {
    display: flex;
    align-items: center;
    height: 32px;
    color: #606266;
  }
  .import-staff-file-name i {
    margin-right: 8px;
  }
  .import-staff-file-name span {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .import-staff-file-name .el-button {
    padding: 0;
    color: #909399;
  }
  </style>
  <style lang="scss">
  .actual-cell-red {
    background-color: #FEF0F0 !important;
    color: #F56C6C !important;
  }
  .actual-cell-red .vxe-cell,
  .actual-cell-red .vxe-cell span,
  .actual-cell-red .vxe-cell span.link {
    color: #F56C6C !important;
  }
  .export-timesheet-dialog {
    .el-dialog__header {
      padding: 24px 28px 12px;
    }
    .el-dialog__body {
      padding: 22px 36px 0;
    }
    .el-dialog__footer {
      padding: 10px 26px 24px;
      text-align: right;
    }
    .el-form-item {
      margin-bottom: 22px;
    }
    .el-form-item__content {
      margin-left: 170px !important;
    }
    .export-employee-type-item .el-form-item__content {
      padding-top: 8px;
    }
  }
  </style>
